import { useEffect, useId } from "react";
import { usePrintContext } from "./PrintProvider.tsx";

export interface UsePrintDrainOptions {
    hasNextPage: boolean;
    isFetchingNextPage: boolean;
    isPending: boolean;
    isPlaceholderData: boolean;
    isSettling: boolean;
    loadMore: () => void;
}

export function usePrintDrain({ hasNextPage, isFetchingNextPage, isPending, isPlaceholderData, isSettling, loadMore }: UsePrintDrainOptions) {
    const { isPreparing, coordinator } = usePrintContext();
    const participantId = useId();

    const isReady = !isPending && !isPlaceholderData && !isFetchingNextPage && !hasNextPage && !isSettling;

    useEffect(() => {
        coordinator.setReadiness(participantId, isReady);
        // oxlint-disable-next-line react/exhaustive-effect-dependencies -- isPreparing re-asserts readiness, see above
    }, [coordinator, participantId, isReady, isPreparing]);

    useEffect(() => () => coordinator.remove(participantId), [coordinator, participantId]);

    useEffect(() => {
        if (!isPreparing || isPending || isPlaceholderData || isFetchingNextPage || !hasNextPage) {
            return;
        }

        loadMore();
    }, [isPreparing, isPending, isPlaceholderData, isFetchingNextPage, hasNextPage, loadMore]);
}
